var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pricing_calculator"}},[_c('Tiers'),_c('Calculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }